import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FcPaginatorComponent } from '@core/components/fc-paginator/fc-paginator.component';
import { Subject } from 'rxjs';
import { debounceTime, switchMap, takeUntil, tap } from 'rxjs/operators';
import { GroupService } from '../../../../services/groups-api.service';
var LinkedUsersComponent = /** @class */ (function () {
    function LinkedUsersComponent(groupService) {
        this.groupService = groupService;
        this.subscriptions = new Subject();
        this.page = null;
        this.isLoading = true;
        this.pageSize = 5;
        this.currentPage = 0;
        this.isPageChanging = false;
    }
    LinkedUsersComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.searchInputValue.valueChanges.pipe(debounceTime(500)).subscribe(function () {
            _this.isLoading = true;
            _this.reload.next();
        });
        this.reload.pipe(takeUntil(this.subscriptions), tap(function () { return _this.isLoading = true; }), switchMap(function () { return _this.searchUsers(); }), tap(function () {
            _this.isLoading = false;
        })).subscribe(function (userPage) {
            _this.page = userPage;
        });
        this.reload.next();
    };
    LinkedUsersComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.next();
        this.subscriptions.complete();
    };
    LinkedUsersComponent.prototype.unlinkUser = function (userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.groupId) {
                            return [2 /*return*/];
                        }
                        this.isLoading = true;
                        return [4 /*yield*/, this.groupService.unlinkUser(userId, this.groupId)];
                    case 1:
                        _a.sent();
                        this.isLoading = false;
                        this.reload.next();
                        return [2 /*return*/];
                }
            });
        });
    };
    LinkedUsersComponent.prototype.searchUsers = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (!this.groupId) {
                    return [2 /*return*/, null];
                }
                return [2 /*return*/, this.groupService.listUsers({
                        limit: this.pageSize,
                        offset: this.currentPage * this.pageSize,
                        where: {
                            name_or_email_contains: this.searchInputValue.value || '',
                            group_id: this.groupId
                        }
                    })];
            });
        });
    };
    LinkedUsersComponent.prototype.onPageChange = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.currentPage = event.pageIndex;
                        this.isPageChanging = true;
                        _a = this;
                        return [4 /*yield*/, this.searchUsers()];
                    case 1:
                        _a.page = _b.sent();
                        this.isPageChanging = false;
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    return LinkedUsersComponent;
}());
export { LinkedUsersComponent };
